import { AfterViewInit, Component } from '@angular/core';
import { Router, RoutesRecognized } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { filter, fromEvent, pairwise, Unsubscribable } from 'rxjs';
import { Subject } from 'rxjs/internal/Subject';
import { AppState } from './shared/common/utils/AppState';
import { UtilComponent } from './shared/common/utils/UtilComponent';
import { environment } from 'environments/environment';
import { bootstrapAppAt } from 'lowcoder-sdk';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit {
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    isShowUnlockSession: boolean = false;
    countInterval: any;
    countIdle = 0;
    private _unsubscribableArray: Array<Unsubscribable> = [];

    constructor(private _router: Router,
        private _appState: AppState,
        private _translateService: TranslocoService,
        private _utilComp: UtilComponent
    ) {
        this._router.events
            .pipe(filter((evt: any) => evt instanceof RoutesRecognized), pairwise())
            .subscribe((events: RoutesRecognized[]) => {
                localStorage.setItem('PREVIORS_URL', events[0].urlAfterRedirects);
                localStorage.setItem('CURRENT_URL', events[1].urlAfterRedirects)
            })
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.startUserIdle();
        }, 10000);

        if (environment.production) {
            const consoleError = console.error;
            const me = this;
            console.error = function () {
                const msgs = [];
                while (arguments.length) {
                    const err = arguments[0];
                    if (err && (typeof (err) === 'string' || err instanceof String)) {
                        if (err.indexOf('*******************************************') > -1 ||
                            err.indexOf('ag-Grid Enterprise') > -1 ||
                            err.indexOf('ag-Grid') > -1 ||
                            err.indexOf('AG Grid Enterprise License') > -1 ||
                            err.indexOf('Invalid License') > -1 ||
                            err.indexOf('License Key Not Found') > -1 ||
                            err.indexOf('All AG Grid Enterprise features are unlocked') > -1 ||
                            err.indexOf('it is not licensed for development projects intended') > -1 ||
                            err.indexOf('info@ag-grid.com') > -1 ||
                            err.indexOf('are trying to use was released on') > -1 ||
                            err.indexOf('                                                                                                                          ') > -1
                        ) {
                            break;
                        }
                    }
                    msgs.push([].shift.call(arguments));
                }
                consoleError.apply(console, msgs);
            };
        }

        setTimeout(() => {
            this.loadLowcoder();
        }, 5000);
    }

    loadLowcoder(): void {
        try {
            const node = document.querySelector("#lowcoderEmpty");
            const appId = window['LOWCODER_FORM_KEY_EMPTY'];
            bootstrapAppAt(appId, node, {
                baseUrl: window['HOST_NAME_LOWCODER']
            });
        } catch (error) {
            console.log(error);
        }
    }

    startUserIdle() {
        if (window['isMobile']) {
            return;
        }

        this._unsubscribableArray.push((fromEvent(window, 'click').subscribe(() => {
            if (window['isMobile']) {
                return;
            }
            if (this.isShowUnlockSession) return;

            let hash: string = location.hash;
            hash = hash.toString().replace('#', '');
            if (this._appState.checkRoutePassLogin(hash)) {
                return;
            }
            this.countIdle = 0;
            // clearInterval(this.countInterval);
            //this.countInterval = null;
            clearInterval(this.countInterval);
            this.countInterval = null;
            this._unsubscribeAll.next(null);
            this._unsubscribeAll.complete();
            setTimeout(() => {
                this.setCountInterVal();
            }, 0);
        })));
    }

    setCountInterVal(): void {
        try {
            this.countInterval = setInterval(() => {
                if (this.isShowUnlockSession) return;
                let hash: string = location.hash;
                hash = hash.toString().replace('#', '');
                if (this.isShowUnlockSession || this._appState.checkRoutePassLogin(hash)) {
                    return;
                }
                this.countIdle++;
                if (this.countIdle === window['SESSION_TIME_OUT'] && !this.isShowUnlockSession) {
                    this.countIdle = 0;
                    this.isShowUnlockSession = true;
                    this._utilComp.openConfirmationDialogCancel(this._translateService.translate('GENERAL.UNLOCK_YOUR_SESSION_2'), () => {
                        this._router.navigate(['/unlock-session']);
                        this.isShowUnlockSession = false;
                    }, '', this._translateService.translate('CONTROL.CLOSE'), false);
                }
            }, 60000);
        } catch (error) {
            console.log(error);
        }
    }
}
